import styled from 'styled-components';

export const Shadow = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 8px 2px rgba(85, 85, 85, 0.08);
  border-radius: 8px;
`;
